module.exports = __webpack_public_path__ + "img/payment_mb_05.c1b6243d.png";